import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import EducacaoService from '../../../services/contasEducacao'
import Despesa from './despesa';

const ListarDespesas = () => {

    const [despesas, setDespesas] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchDespesas() {
        const response = await EducacaoService.listarDespesas();
        if (response.data.length >= 1) {
            setDespesas(response.data)
            setVazio(false)
        } else {
            setDespesas([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchDespesas();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDespesas={setDespesas}
                    setVazio={setVazio}
                    fetchDespesas={fetchDespesas}
                    despesas={despesas}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <br/>
                    <h5>Despesas da Secretaria Municipal de Educação</h5>
                    <Row xs={1} lg={3}>
                        {despesas.map((despesa, index) =>
                            <Despesa
                                despesa={despesa}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarDespesas;